/** false — реальная запись в Finansist; true — только проверка (dry_run), без создания документов. */
export const FINANSIST_PUSH_DRY_RUN = false;

export const getLevelName = (level) => {
  if (typeof level === "string") return level;
  return level?.name || level?.access_level_name || level?.title || "";
};

export const hasFinansistPushRole = (userData) => {
  const accessLevels = userData?.access_levels || [];
  return accessLevels.some((level) => {
    const levelName = getLevelName(level);
    return ["АДМС", "ФИН"].includes(levelName);
  });
};

/** Список сотрудников из ответа salary-approval-v2 (groups или плоские rows). */
export const buildEmployeesFromApprovalDetail = (detail) => {
  const byId = new Map();
  const addRow = (row) => {
    const id = Number(row?.user_id);
    if (!Number.isFinite(id) || id <= 0) return;
    if (byId.has(id)) return;
    const name = String(row?.full_name || "").trim();
    byId.set(id, {
      id,
      name: name || `Пользователь (id: ${id})`,
    });
  };

  const groups = detail?.table_data?.groups || [];
  for (const group of groups) {
    for (const row of group.rows || []) {
      addRow(row);
    }
  }
  for (const row of detail?.table_data?.rows || []) {
    addRow(row);
  }

  return Array.from(byId.values()).sort((a, b) =>
    a.name.localeCompare(b.name, "ru"),
  );
};

/** Карта user_id → ФИО из ответа salary-approval-v2 (таблица согласования). */
export const buildUserIdToNameFromApprovalDetail = (detail) => {
  const map = new Map();
  for (const employee of buildEmployeesFromApprovalDetail(detail)) {
    map.set(employee.id, employee.name);
  }
  return map;
};

/** user_id с ошибками из ответа push-payroll. */
export const getFailedUserIdsFromPushResult = (result) => {
  const failed = (
    Array.isArray(result?.per_user) ? result.per_user : []
  ).filter((u) => u && u.ok === false);
  const ids = [];
  for (const entry of failed) {
    const uid = Number(entry.user_id);
    if (Number.isFinite(uid) && uid > 0) ids.push(uid);
  }
  return ids;
};

export const formatFinansistPushResultMessage = (result, userIdToName) => {
  const usersOk = Number(result?.users_ok || 0);
  const usersFailed = Number(result?.users_failed || 0);
  const lines = [
    "Отправка в Finansist выполнена.",
    `Успешно: ${usersOk}`,
    `С ошибками: ${usersFailed}`,
  ];

  const failed = (
    Array.isArray(result?.per_user) ? result.per_user : []
  ).filter((u) => u && u.ok === false);
  if (failed.length === 0) {
    return lines.join("\n");
  }

  lines.push("");
  lines.push("Детали по ошибкам:");
  for (const entry of failed) {
    const uid = Number(entry.user_id);
    const who =
      Number.isFinite(uid) && uid > 0
        ? userIdToName?.get(uid) || `Пользователь (id: ${uid})`
        : "Неизвестный пользователь";
    const detail =
      String(entry.detail || "").trim() ||
      String(entry.empty_reason_hint || "").trim() ||
      "Причина не указана.";
    lines.push(`• ${who}: ${detail}`);
    const unresolved = entry.unresolved_projects;
    if (Array.isArray(unresolved) && unresolved.length) {
      lines.push(`  Неразрешённые проекты: ${unresolved.join(", ")}`);
    }
  }
  return lines.join("\n");
};
